import React, {useState} from 'react'
import './Home.css'
import {InlineWidget} from 'react-calendly'



function Calandly() {

  return (
    <div>
        <div className="container-fluid cal-div1">
            <h1 className='book-text'>Book A Meeting</h1>
            <div className='book-div2'>
                  <InlineWidget url="https://calendly.com/iamqasim/30min" styles={{height:'700px'}}></InlineWidget>
              {/* <div class="calendly-inline-widget" data-url="https://calendly.com/iamqasim/30min" style={{"minWidth":"320px","height":"700px"}}></div> */}
              {/* <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script> */}
        </div>
        </div>
    </div>

  )
}

export default Calandly
